import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { useCallback } from "react";
import { apiScopeRequest } from "./msal";

/** Returns a function that yields a fresh access token for the API audience. */
export function useApiTokenFetcher(apiScope: string) {
  const { instance, accounts } = useMsal();

  return useCallback(async () => {
    const account = accounts[0];
    if (!account) throw new Error("not signed in");

    try {
      const r = await instance.acquireTokenSilent({
        ...apiScopeRequest(apiScope),
        account,
      });
      return r.accessToken;
    } catch (err) {
      if (err instanceof InteractionRequiredAuthError) {
        const r = await instance.acquireTokenPopup(apiScopeRequest(apiScope));
        return r.accessToken;
      }
      throw err;
    }
  }, [instance, accounts, apiScope]);
}
